module.exports = __webpack_public_path__ + "img/cover-image@3x.ff31bc26.png";